module.exports = __webpack_public_path__ + "img/waterMark300.c7a05917.png";